t = require('views/internal/teacup-with-helpers')('billing_contact')
supportedLocales = require 'data/supported-locales'

module.exports = t.renderable ({ fullName, email, locale }) ->
  t.div '.error', { style: 'display:hidden' }

  t.form ->

    t.label { for: 'billingContactFullName' }, ->
      t.format 'name'
    t.input '.text', { name: 'billingContactFullName', type: 'text', id: 'billingContactFullName', value: fullName, maxlength: '50' }

    t.label { for: 'billingContactEmail' }, ->
      t.format 'email'
    t.input '.text', { name: 'billingContactEmail', type: 'text', id: 'billingContactEmail', value: email }

    t.label { for: 'billingContactLocale' }, ->
      t.format 'language'
    t.select { name: 'billingContactLocale', id: 'billingContactLocale' }, ->
      for { code: value, name } in supportedLocales
        selected = value.toLowerCase() == locale.toLowerCase()
        t.option { value, selected }, ->
          t.text name

    t.input '.primary.js-submit', { type: 'submit', value: t.l('save') }




// WEBPACK FOOTER //
// ./app/scripts/views/templates/billing_contact.coffee